// @ts-nocheck 关闭本文件类型检查，避免 import('@/xxx.vue') 被 TS 标红（Vite 运行解析正常）
import { AuthMap } from '@/constant/index';
import {
  ENTERPRISE_SETTING_PAGE_TYPE,
  ENTERPRISE_ISSUE_SETTING_ROUTE_NAME,
  RESOURCE_CENTER_PAGE_TYPE
} from '@/constant/route';
import { enterpriseRoutePath } from '@/router/utils/enterprisePath';
import { VITE_HOST } from '@/utils/tools';

const enterprisePType = ENTERPRISE_SETTING_PAGE_TYPE;

/** 进入 homepage（SPA 根路径）时整页回主站根；域名与 VITE_HOST + transformUrl 一致（atomgit / gitcode 等） */
const mainSiteHomeRoute = {
  path: '/',
  name: 'homepage',
  component: { render: () => null as any },
  beforeEnter() {
    const root = `${(VITE_HOST() || '').replace(/\/$/, '')}/`;
    window.location.replace(root);
    return false;
  }
};

const enterpriseShellRoute = {
  path: enterpriseRoutePath(':namespace'),
  component: () => import('@/layouts/EnterpriseLayout/index.vue'),
  meta: {
    type: 'org',
    needLogin: true,
    hasMobile: true,
    permission: 'visitor',
    reportTitle: '企业',
    headerClassName: 'gray-bg'
  },
  children: [
    // 兼容把路由名 enterpriseDetail 拼进 URL 的旧链接 /:namespace/enterpriseDetail → 规范为 /:namespace
    {
      path: 'enterpriseDetail',
      redirect: (to) => ({
        path: `/${to.params.namespace}`,
        replace: true
      })
    },
    {
      path: '',
      name: 'enterpriseDetail',
      component: () => import('@/views/OrgSetting/EnterpriseMessage/index.vue'),
      meta: {
        title: '企业信息',
        pType: enterprisePType, // 表示界面归属于哪个tab菜单
        permission: 'visitor'
      }
    },
    {
      path: 'home',
      name: 'home',
      redirect: { name: 'enterpriseDetail' }
    },
    {
      path: 'enterpriseSetting',
      name: 'enterpriseSetting',
      meta: {
        title: '企业设置',
        pType: enterprisePType, // 表示界面归属于哪个tab菜单
        permission: 'visitor'
      },
      redirect: { name: 'enterpriseDetail' }
    },
    {
      path: 'member',
      name: 'enterpriseSettingMember',
      component: () => import('@/views/OrgSetting/Member/index.vue'),
      meta: {
        title: '成员设置',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'rolesPermission',
      name: 'enterpriseSettingRolesPermission',
      component: () => import('@/views/OrgSetting/RolesPermission/index.vue'),
      meta: {
        title: '组织角色与权限管理',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'default',
      name: 'enterpriseSettingDefault',
      component: () => import('@/views/OrgSetting/Default/index.vue'),
      meta: {
        title: '默认设置',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'default/access_rules',
      name: 'enterpriseSettingDefaultAccessRules',
      component: () => import('@/views/OrgSetting/AccessRules/index.vue'),
      meta: {
        title: '准入规则',
        permission: 'admin',
        pType: enterprisePType
      }
    },
    {
      path: 'issues',
      name: ENTERPRISE_ISSUE_SETTING_ROUTE_NAME,
      component: () => import('@/views/OrgSetting/issue/index.vue'),
      meta: {
        title: 'Issue增强',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'enterprise-labels',
      name: 'enterpriseSettingEnterpriseLabels',
      component: () => import('@/views/OrgSetting/EnterpriseLabels/index.vue'),
      meta: {
        title: '企业 Label',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'apps',
      name: 'enterpriseApps',
      component: () => import('@/views/UserSetting/Apps/index.vue'),
      meta: {
        title: 'AtomGit Apps',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'apps/:id',
      name: 'enterpriseAppsDetail',
      component: () => import('@/views/OrgSetting/Apps/EnterpriseDetail.vue'),
      meta: {
        title: '配置应用',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'issues/status/:typeId',
      name: 'enterpriseSettingIssuesStatus',
      component: () => import('@/views/OrgSetting/issue/status/index.vue'),
      meta: {
        title: 'Issue增强-状态设置',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'issues/workflow/:typeId',
      name: 'enterpriseSettingIssuesWorkflow',
      component: () => import('@/views/OrgSetting/issue/workflow/index.vue'),
      meta: {
        title: 'Issue增强-工作流设置',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'issues/priority/:typeId',
      name: 'enterpriseSettingIssuesPriority',
      component: () => import('@/views/OrgSetting/issue/priority/index.vue'),
      meta: {
        title: 'Issue增强-优先级设置',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'issues/customField/:typeId',
      name: 'enterpriseSettingIssuesCustomField',
      component: () => import('@/views/OrgSetting/issue/CustomField/index.vue'),
      meta: {
        title: 'Issue增强-自定义字段设置',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'aliasSetting',
      name: 'enterpriseSettingAliasSetting',
      component: () => import('@/views/OrgSetting/AliasSetting/index.vue'),
      meta: {
        title: '我的企业信息',
        permission: 'visitor',
        pType: enterprisePType
      }
    },
    {
      path: 'organization',
      name: 'enterpriseSettingOrganization',
      component: () => import('@/views/OrgSetting/Organization/index.vue'),
      meta: {
        title: '组织管理',
        permission: 'admin',
        pType: enterprisePType
      }
    },
    {
      path: 'webhook',
      name: 'enterpriseSettingWebhook',
      component: () => import('@/views/OrgSetting/EnterpriseWebhook/index.vue'),
      meta: {
        title: '企业WebHook',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'webhook/create',
      name: 'enterpriseSettingWebhookCreate',
      component: () => import('@/views/OrgSetting/EnterpriseWebhook/Create/index.vue'),
      meta: {
        title: '新建 WebHook',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'webhook/edit/:webhookId',
      name: 'enterpriseSettingWebhookEdit',
      component: () => import('@/views/OrgSetting/EnterpriseWebhook/Detail/index.vue'),
      meta: {
        title: 'WebHook',
        permission: 'maintainer',
        pType: enterprisePType
      }
    },
    {
      path: 'resourceCenter',
      name: 'resourceCenter',
      redirect: { name: 'enterpriseSettingMilestone' },
      meta: {
        title: '资源中心',
        permission: 'maintainer',
        pType: RESOURCE_CENTER_PAGE_TYPE
      }
    },
    {
      path: 'issue-list/:viewId?',
      name: 'enterpriseIssueList',
      component: () => import('@/views/OrgSetting/IssueList/info.vue'),
      meta: {
        title: '企业issue列表',
        permission: 'custom',
        enterpriseAuthority: AuthMap.issue.update,
        pType: RESOURCE_CENTER_PAGE_TYPE
      }
    },
    {
      path: 'milestones',
      name: 'enterpriseSettingMilestone',
      component: () => import('@/views/OrgSetting/Milestone/index.vue'),
      meta: {
        title: '企业里程碑',
        permission: 'maintainer',
        pType: RESOURCE_CENTER_PAGE_TYPE
      }
    },
    {
      path: 'milestones/create',
      name: 'enterpriseSettingMilestoneCreate',
      component: () => import('@/views/OrgSetting/Milestone/Create/index.vue'),
      meta: {
        title: '创建企业里程碑',
        permission: 'maintainer',
        pType: RESOURCE_CENTER_PAGE_TYPE
      }
    },
    {
      path: 'milestones/:milestoneId(\\d+)',
      name: 'enterpriseSettingMilestoneDetail',
      component: () => import('@/views/OrgSetting/Milestone/Detail/index.vue'),
      meta: {
        title: '企业里程碑详情',
        permission: 'maintainer',
        pType: RESOURCE_CENTER_PAGE_TYPE
      }
    },
    {
      path: 'milestones/edit/:milestoneId(\\d+)',
      name: 'enterpriseSettingMilestoneEdit',
      component: () => import('@/views/OrgSetting/Milestone/Create/index.vue'),
      meta: {
        title: '编辑企业里程碑',
        permission: 'maintainer',
        pType: RESOURCE_CENTER_PAGE_TYPE
      }
    }
  ]
};

const baseNorm = (import.meta.env.BASE_URL || '/').replace(/\/?$/, '/');
const isEnterpriseSubApp = baseNorm === '/enterprises/' || baseNorm.endsWith('/enterprises/');

// 企业子路径部署时根路径 / 需显式注册，否则 /enterprises/ 无匹配；与主站根路径行为一致：回主站
export default isEnterpriseSubApp
  ? [mainSiteHomeRoute, enterpriseShellRoute]
  : [enterpriseShellRoute, mainSiteHomeRoute];
